/* Mykotheke – kolekcija: filteri bez novog učitavanja, broj uz svaku vrijednost, izabrani filteri kao oznake,
   „Weitere anzeigen“ (24 po 24) i povratak na isto mjesto (broj prikazanih se pamti u istoriji).
   Stanje je u adresi: ?kat=…&pilz=…&marke=…&preis=…&bio=1&lager=1 (više vrijednosti odvojeno zarezom). */
(() => {
  const root = document.querySelector("[data-coll]");
  const grid = document.querySelector("[data-collection-grid]");
  if (!root || !grid) return;
  const drawer = document.querySelector("[data-filter-drawer]");
  const cards = [...grid.querySelectorAll(".card")];
  const STEP = 24;
  const FACETS = ["kat", "pilz", "marke", "preis"];
  const FLAGS = ["bio", "lager"];

  // vrijednost kartice za svaki filter
  const val = {
    kat: (c) => (c.dataset.cats || "").split(" ").filter(Boolean),
    pilz: (c) => [c.dataset.pilz].filter(Boolean),
    marke: (c) => [c.dataset.brand].filter(Boolean),
    preis: (c) => [c.dataset.price],
  };
  const flag = { bio: (c) => c.dataset.bio === "true", lager: (c) => c.dataset.avail === "true" };

  // stanje iz adrese
  const q = new URLSearchParams(location.search);
  const state = Object.fromEntries(FACETS.map((f) => [f, new Set((q.get(f) || "").split(",").filter(Boolean))]));
  FLAGS.forEach((f) => (state[f] = q.get(f) === "1"));
  let shown = (history.state && history.state.mkShown) || STEP;

  const label = (facet, v) => {
    if (facet === "pilz") return v.charAt(0).toUpperCase() + v.slice(1);
    const inp = drawer?.querySelector(`[data-facet="${facet}"] input[value="${CSS.escape(v)}"]`);
    return inp ? inp.nextElementSibling.textContent : v;
  };
  const matches = (c, skip) => {
    for (const f of FACETS) {
      if (f === skip || !state[f].size) continue;
      if (!val[f](c).some((x) => state[f].has(x))) return false;
    }
    for (const f of FLAGS) if (f !== skip && state[f] && !flag[f](c)) return false;
    return true;
  };
  const activeCount = () => FACETS.reduce((n, f) => n + state[f].size, 0) + FLAGS.filter((f) => state[f]).length;

  const syncUrl = () => {
    const u = new URL(location.href);
    FACETS.forEach((f) => (state[f].size ? u.searchParams.set(f, [...state[f]].join(",")) : u.searchParams.delete(f)));
    FLAGS.forEach((f) => (state[f] ? u.searchParams.set(f, "1") : u.searchParams.delete(f)));
    history.replaceState({ ...(history.state || {}), mkShown: shown }, "", u);
  };

  const render = () => {
    const hit = cards.filter((c) => matches(c));
    let n = 0;
    cards.forEach((c) => { const on = hit.includes(c) && n < shown; if (on) n++; c.hidden = !on; });
    // brojevi
    root.querySelector("[data-result-count]").textContent = hit.length;
    drawer?.querySelector("[data-apply-count]") && (drawer.querySelector("[data-apply-count]").textContent = hit.length);
    const more = root.querySelector("[data-more]");
    const rest = hit.length - n;
    more.hidden = rest <= 0;
    more.textContent = `Weitere ${Math.min(rest, STEP)} von ${rest} Produkten anzeigen`;
    root.querySelector("[data-empty]").hidden = hit.length > 0;
    // brojevi uz vrijednosti: sa svim ostalim filterima, bez ovog
    drawer?.querySelectorAll("[data-facet]").forEach((fs) => {
      const f = fs.dataset.facet;
      fs.querySelectorAll("label").forEach((lab) => {
        const inp = lab.querySelector("input");
        let cnt;
        if (inp.hasAttribute("data-flag")) { const fl = inp.value; cnt = cards.filter((c) => matches(c, fl) && flag[fl](c)).length; inp.checked = state[fl]; }
        else { cnt = cards.filter((c) => matches(c, f) && val[f](c).includes(inp.value)).length; inp.checked = state[f].has(inp.value); }
        lab.querySelector("[data-n]").textContent = cnt;
        inp.disabled = !cnt && !inp.checked;
        lab.classList.toggle("is-off", inp.disabled);
      });
    });
    // brza dugmad i oznake
    root.querySelectorAll("[data-quick]").forEach((b) => b.setAttribute("aria-pressed", state[b.dataset.quick]));
    const chips = root.querySelector("[data-chips]");
    const list = [];
    FACETS.forEach((f) => state[f].forEach((v) => list.push([f, v, label(f, v)])));
    FLAGS.forEach((f) => state[f] && list.push([f, "1", f === "bio" ? "Nur BIO" : "Nur verfügbare"]));
    chips.hidden = !list.length;
    chips.innerHTML = list.map(([f, v, l]) => `<button type="button" class="chip-x" data-rm-f="${f}" data-rm-v="${v}" aria-label="Filter ${l} entfernen">${l}<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"/></svg></button>`).join("") +
      (list.length > 1 ? '<button type="button" class="link-btn" data-reset>Alle löschen</button>' : "");
    const badge = root.querySelector("[data-filter-count]");
    badge.hidden = !activeCount(); badge.textContent = activeCount();
  };

  const change = () => { shown = STEP; render(); syncUrl(); };

  drawer?.addEventListener("change", (e) => {
    const inp = e.target.closest("input"); if (!inp) return;
    if (inp.hasAttribute("data-flag")) state[inp.value] = inp.checked;
    else { const f = inp.closest("[data-facet]").dataset.facet; inp.checked ? state[f].add(inp.value) : state[f].delete(inp.value); }
    change();
  });
  document.addEventListener("click", (e) => {
    const quick = e.target.closest("[data-quick]");
    if (quick) { state[quick.dataset.quick] = !state[quick.dataset.quick]; change(); return; }
    const rm = e.target.closest("[data-rm-f]");
    if (rm) { const f = rm.dataset.rmF; FLAGS.includes(f) ? (state[f] = false) : state[f].delete(rm.dataset.rmV); change(); return; }
    if (e.target.closest("[data-reset]")) { FACETS.forEach((f) => state[f].clear()); FLAGS.forEach((f) => (state[f] = false)); change(); return; }
    if (e.target.closest("[data-more]")) {
      const first = cards.find((c) => c.hidden && matches(c));
      shown += STEP; render(); syncUrl();
      first?.querySelector("a.title")?.focus({ preventScroll: true }); // tastatura nastavlja od prvog novog proizvoda
      return;
    }
    if (e.target.closest("[data-open-filter]")) { openF(true); return; }
    if (e.target.closest("[data-close-filter]") || (e.target.closest(".scrim") && document.body.classList.contains("filter-open"))) openF(false);
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && document.body.classList.contains("filter-open")) openF(false); });

  let last = null;
  const openF = (on) => {
    document.body.classList.toggle("filter-open", on);
    drawer.setAttribute("aria-hidden", on ? "false" : "true");
    root.querySelector("[data-open-filter]").setAttribute("aria-expanded", on);
    if (on) { last = document.activeElement; drawer.focus(); } else last?.focus();
  };

  // sortiranje preko Shopifyja; filteri ostaju u adresi
  root.querySelector("[data-sort]")?.addEventListener("change", (e) => {
    const u = new URL(location.href); u.searchParams.set("sort_by", e.target.value); location.assign(u);
  });

  render();
})();
